import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import NotificationElement from "./NotificationElement";
import { useNotifications } from "../../Context/NotificationProvider";
import { userService } from "../../Api/Services/UserService";
import { HomeIcon } from "../../Components/Icons/HomeIcon";

interface NotificationListProps {}

const NotificationList: React.FunctionComponent<NotificationListProps> = () => {
  const { t } = useTranslation();

  const { notifications, fetchNotifications } = useNotifications();

  useEffect(() => {
    const markNotificationsAsRead = async () => {
      try {
        if (notifications?.hasUnread) {
          await userService.readNotification();
          console.log('Read notifications');
          fetchNotifications(null);
        }
      } catch (error) {
        console.error('Error reading notifications:', error);
      }
    };

    if (typeof notifications?.hasUnread !== 'undefined') {
      markNotificationsAsRead();
    }
  }, [notifications?.hasUnread, fetchNotifications]);

  const handleDelete = async (id: number): Promise<void> => {
    try {
      await userService.deleteNotification(id);
      console.log('Delete notification:', id);
    } catch (error) {
      console.error('Error deleting notification:', error);
    }
    fetchNotifications(null);
  };

  return (
    <div className="view-container background-white">
      <div className="view-content">

        <div className="navigationbar navigationbar--dark mb-6">
          <div className="navigationbar__left">
            <Link to="/menu" className="navigationbar__button">
              <HomeIcon/>
            </Link>
          </div>
          <div className="navigationbar__center">
            <div className="navigationbar__title">{t("Notifications")}</div>
          </div>
          <div className="navigationbar__right">
          </div>
        </div>

        <div className="notification-list">
          {notifications?.notifications && Array.isArray(notifications.notifications) ? (
              notifications.notifications.length > 0 ? (
                  notifications.notifications.map((notification) => (
                      <div className="mb-4" key={notification.id}>
                        <NotificationElement notification={notification} handleDelete={handleDelete}/>
                      </div>
                  ))
              ) : (
                  <div className="text-center text-gray-500">
                    You don't have any notifications yet.
                  </div>
              )
          ) : (
              <div className="text-center text-gray-500">
                You don't have any notifications yet.
              </div>
          )}
        </div>

      </div>
    </div>
  )

};

export default NotificationList;
